import util from '@/common/util';
import { mapState, mapActions } from '@/store/helpers';
import { MAP_CHANGE_MUTATION } from './_store/types';

export default {
    i18next: {
        ns: 'md-search-result'
    },
    props: [
        'center',
        'address',
        'zoom',
        'boundary',
        'geometry',
        'showSchool',
        'mapSearchText',
        'mapDrawTip',
        'showMap'
    ],
    data: function() {
        this.psMap = new Promise(resolve => {
            this.psResolve = resolve;
        });
        return {
            inited: false,
            mapSearch: false,
            houseList: null,
            markerEventMap: {
                house: {
                    click: data => {
                        this.showHouseList(data);
                    }
                }
            }
        };
    },
    inject: ['scrollwheel', 'hidePlot', 'hideRedo'],
    provide() {
        return {
            isListing: true
        };
    },
    computed: {
        ...mapState({
            "keywords": "keywords",
            "result": "result",
            "mapResult": "mapResult",
            "mapCondition": "mapCondition",
            "layout": "layout",
            "mapType": "mapType",
            "listingMarkers": "listingMarkers",
            "isBigMap": "isBigMap"
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        markerData() {
            return {
                aggregation: this.mapResult.aggregation || [],
                house: this.mapResult.house || [],
                listing: this.listingMarkers
            };
        },
        mapConfig() {
            return {
                fullscreenControl: false,
            };
        },
        showMapSearch() {
            if (this.inited && !this.mapSearch) {
                return true;
            } else {
                return false;
            }
        },
        tools() {
            let tools = [
                {
                    name: 'zoom',
                    css: this.isMobileSize
                        ? 'right: 15px; bottom: 15px'
                        : 'right: 20px; bottom: 20px'
                },
                {
                    name: 'draw',
                    tip: this.mapDrawTip,
                    css: this.isMobileSize
                        ? 'right: 15px; top: 15px'
                        : 'right: 20px; top: 20px'
                },
                {
                    name: 'school',
                    css: this.isMobileSize
                        ? 'right: 15px; top: 65px'
                        : 'right: 20px; top: 70px',
                    value: this.showSchool
                },
                {
                    name: 'search',
                    text: this.mapSearchText,
                    css: this.isMobileSize
                        ? 'left: 15px; top: 15px'
                        : 'left: 20px; top: 20px;'
                },
                {
                    name: 'maptype',
                    css: this.isMobileSize
                        ? 'left: 15px;bottom: 15px'
                        : 'left: 0;bottom: 0'
                },
                {
                    name: 'nearby',
                    css: this.isMobileSize
                        ? 'right: 15px;bottom: 106px'
                        : 'right: 20px;bottom: 111px'
                }
            ];
            if (this.hidePlot) {
                tools = tools.filter(tool => tool.name !== 'draw');
            }
            if (this.hideRedo) {
                tools = tools.filter(tool => tool.name !== 'search');
            }
            return tools;
        }
    },
    watch: {
        mapCondition: {
            deep: true,
            handler: function() {
                this.mapSearch = this.mapCondition.mapSearch;
            }
        },
        geometry: {
            immediate: true,
            deep: true,
            handler: function(val) {
                this.addBoundaries(val);
            }
        },
        isMobileSize: {
            immediate: true, // Executed immediately when monitoring starts
            //  mobile terminal   first time entry listing of map area
            handler: function(val) {
                if (
                    val &&
                    !this.mapCondition.mapSearch &&
                    !this.mapCondition.mapPath &&
                    this.keywords.length === 0 &&
                    this.layout === 'map' &&
                    !this.isFromAlertMail &&
                    !this.noUsePresetCondition
                ) {
                    this.$EventBus.$emit('siteTrack', {
                        action: 'mapsearch',
                        trackType: 'map-event',
                        ele: this.$el
                    });
                }
            }
        }
    },
    methods: {
        ...mapActions({
            "mapChangeMutation": MAP_CHANGE_MUTATION
        }),
        
        showHouseList(data) {
            if (this.isMobileSize) {
                setTimeout(() => {
                    this.houseList = data.items || [];
                }, 100);
            }
        },
        hideHouseList() {
            this.houseList = null;
        },
        onMapChange(data) {
            if (!(this.showMap || this.showMap == undefined)) {
                return;
            }
            if (!this.inited) {
                if (this.mapCondition.mapPath) {
                    let mapPath = this.mapCondition.mapPath;
                    if (typeof mapPath === 'string') {
                        if (!mapPath.startsWith('[')) {
                            mapPath = '[' + mapPath + ']';
                        }
                        mapPath = JSON.parse(mapPath);
                    }

                    this.$refs.map.setZoom(mapPath, true); //update setzoom animate
                }
            }
            this?.setInited?.();
            this.mapChangeMutation(data);
        },
        addBoundaries(geometry) {
            this.psMap.then(() => {
                this.$refs.map.clearBoundary();
                Array.isArray(geometry) &&
                    geometry.forEach(geo => this.$refs.map.addBoundary(geo));
            });
        },
        resize() {
            this.psMap.then(() => {
                this.$refs.map &&
                    this.$refs.map.mapResize &&
                    this.$refs.map.mapResize();
            });
        },
        mapLoad() {
            this.psResolve();
        },
        clearBoundary() {
            this.psMap.then(() => {
                this.$refs.map.clearBoundary();
            });
        }
    },
    created() {
        this.setInited = util.singleSetTimeOut(() => {
            //  performance optimization ， avoid creating many  timeout
            this.inited = true;
        }, 500);
    }
};
